export default "<div [chart]=\"humidityInstant\"></div>"